import { Injectable } from '@angular/core';
import { IJobNameSearch, JobSearch, BaseResponse } from '../models';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  constructor(private httpClient: HttpClient) { }
  //#region JobService Api endPoints

  public search(data: IJobNameSearch): Observable<Array<JobSearch>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.JOB.SEARCH}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  //#endregion
  
}
